// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qZq6","textarea":"styles_textarea__2xGdH"};